import { creditosFinanceiros } from '@/mocks/creditosFinanceiros';
import { calcularPontosFinanceiro } from '@/utils/pontosFinanceiro';

interface AdminPixPagamentoCardProps {
  id: number;
  modalidade: 'pix' | 'pagamento';
  selectedCampaignId: number | null;
  isSelected: boolean;
  onSelect: () => void;
}

const MODALIDADE_CONFIG = {
  pix: {
    label: 'PIX',
    tagBase: 'PIX Personalizado',
    imagem: 'https://static.readdy.ai/image/22e92c18f0b031d861a5e53bf8e362fb/d0bca9b579fa5bbed4a08ef0669cd18f.png',
  },
  pagamento: {
    label: 'Pagamento de Contas',
    tagBase: 'Pagamento Personalizado',
    imagem: 'https://static.readdy.ai/image/22e92c18f0b031d861a5e53bf8e362fb/32c6fb1e1592b974c4b053fbb384b0c1.png',
  },
};

export default function AdminPixPagamentoCard({ id, modalidade, selectedCampaignId, isSelected, onSelect }: AdminPixPagamentoCardProps) {
  const config = MODALIDADE_CONFIG[modalidade];
  const creditoSelecionado = creditosFinanceiros[0] ?? null;
  const pontos = creditoSelecionado ? calcularPontosFinanceiro(creditoSelecionado.valor) : 0;
  const semCampanha = selectedCampaignId === null;
  const resgatados = selectedCampaignId ? ((selectedCampaignId * 47 + id * 23) % 150) + 5 : null;

  return (
    <div className={`bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-all h-full flex flex-col relative ${isSelected ? 'ring-2 ring-blue-500' : ''}`}>
      {/* Checkbox de seleção */}
      <div className="absolute top-2 left-2 z-10">
        <input
          type="checkbox"
          checked={isSelected}
          onChange={onSelect}
          className="w-5 h-5 rounded border-gray-300 text-blue-600 focus:ring-blue-500 cursor-pointer"
        />
      </div>

      {/* Imagem */}
      <div className="relative">
        <img
          src={config.imagem}
          alt={config.label}
          className="w-full h-48 object-cover object-top"
        />
        {/* Badge de pontos */}
        <div className="absolute top-2 right-2 bg-gradient-to-r from-yellow-400 to-orange-500 text-white px-3 py-1.5 rounded-full text-sm font-bold shadow-lg flex items-center gap-1.5">
          <i className="ri-star-fill text-base"></i>
          <span>{pontos.toLocaleString()} XP</span>
        </div>
        {/* Tag de destaque */}
        <div className="absolute bottom-2 left-2 bg-blue-400 text-blue-900 px-2 py-1 rounded-full text-xs font-medium">
          {config.tagBase}
        </div>
      </div>

      {/* Conteúdo */}
      <div className="p-4 flex-1 flex flex-col">
        <h3 className="font-semibold text-gray-900 mb-2 min-h-[3rem]">
          {config.label} — {modalidade === 'pix' ? 'Resgate Instantâneo' : 'Concessionária e Boleto Bancário'}
        </h3>
        <p className="text-gray-600 text-sm mb-3 line-clamp-2 min-h-[2.5rem]">
          O Premiado poderá fazer pagamento de contas de concessionárias e boletos bancários de sua titularidade.
        </p>

        {/* Resgatados por campanha */}
        {resgatados !== null && (
          <p className="text-sm text-gray-500 mb-3">
            <i className="ri-user-received-line mr-1"></i>
            {resgatados} resgatados nesta campanha
          </p>
        )}

        {/* Status de campanha */}
        <div className="mt-auto pt-2">
          {semCampanha ? (
            <div className="w-full py-2.5 rounded-lg bg-gray-100 text-gray-400 font-semibold text-sm flex items-center justify-center gap-2 cursor-not-allowed">
              <i className="ri-information-line"></i>
              Selecione uma campanha
            </div>
          ) : (
            <div className="w-full py-2.5 rounded-lg bg-blue-50 text-blue-700 font-semibold text-sm flex items-center justify-center gap-2 border border-blue-200">
              <i className="ri-checkbox-circle-line"></i>
              Pronto para vincular
            </div>
          )}
        </div>
      </div>
    </div>
  );
}